export function gerarCodigo(): string {
  const ano = new Date().getFullYear()
  const num = Math.floor(100000 + Math.random() * 900000)
  return `4S-${num}-${ano}`
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
}

export function formatDate(dateStr: string): string {
  if (!dateStr) return '-'
  const d = new Date(dateStr)
  return d.toLocaleDateString('pt-BR')
}

export function formatDatetime(dateStr: string): string {
  if (!dateStr) return '-'
  const d = new Date(dateStr)
  return d.toLocaleString('pt-BR')
}

export function nowISO(): string {
  return new Date().toISOString()
}

export function dateInputToISO(dateInput: string): string {
  if (!dateInput) return ''
  return new Date(dateInput + 'T00:00:00').toISOString()
}

